import * as types from '../const/action.types';
import { get, post, put } from '../api/_basic';

export function loadReferences() {
    return async (dispatch) => {
        dispatch(referencesHasErrored(false, ''));
        dispatch(referencesIsLoading(true));
        return get(`${process.env.REACT_APP_API_REFERENCE}`)
            .then((response) => {
                dispatch(referencesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                dispatch(referencesHasErrored(false, ''));
                dispatch(loadReferencesSuccess(items));
            })
            .catch((error) => {
                dispatch(referencesIsLoading(false));
                dispatch(referencesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function addReference(reference) {
    return async (dispatch) => {
        dispatch(referenceIsSaving(true));
        return post(`${process.env.REACT_APP_API_REFERENCE}`, reference)
            .then((response) => {
                dispatch(referenceIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function editReference(reference) {
    return async (dispatch) => {
        dispatch(referenceIsSaving(true));
        return put(`${process.env.REACT_APP_API_REFERENCE}/${reference.id}`, reference)
            .then((response) => {
                dispatch(referenceIsSaving(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((items) => {
                return true;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadReference(id) {
    return async function(dispatch) {
        dispatch(referencesHasErrored(false, ''));
        dispatch(referencesIsLoading(true));
        dispatch(loadReferenceSuccess({}));
        return get(`${process.env.REACT_APP_API_REFERENCE}/${id}`)
            .then((response) => {
                dispatch(referencesIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(referencesHasErrored(false, ''));
                dispatch(loadReferenceSuccess(item));
            })
            .catch((error) => {
                //throw error;
                dispatch(referencesHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function loadReferenceSuccess(data) {
    return {
        type: types.LOAD_REFERENCE_SUCCESS,
        data,
    };
}

export function loadReferencesSuccess(data) {
    return {
        type: types.REFERENCES_SUCCESS,
        data,
    };
}

export function referencesHasErrored(bool, message) {
    return {
        type: types.REFERENCE_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function referencesIsLoading(bool) {
    return {
        type: types.REFERENCES_IS_LOADING,
        isLoading: bool,
    };
}

export function referenceIsSaving(bool) {
    return {
        type: types.REFERENCES_IS_SAVING,
        isLoading: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/references.actions.js